
const ListIcon = () => {
    return (
        <svg width="50" height="45" viewBox="0 0 50 45" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M34.3545 44.9333H4.95455C2.46 44.9333 0.5 42.9733 0.5 40.4788V5.28789C0.5 2.79334 2.46 0.833344 4.95455 0.833344H34.3545C36.8491 0.833344 38.8091 2.79334 38.8091 5.28789V40.4788C38.8091 42.9733 36.8491 44.9333 34.3545 44.9333Z" fill="#FEE7C8" />
            <path d="M31.5037 14.2861H7.53821C6.6473 14.2861 5.93457 13.5733 5.93457 12.6824C5.93457 11.7915 6.6473 11.0788 7.53821 11.0788H31.4146C32.3055 11.0788 33.0182 11.7915 33.0182 12.6824C33.1073 13.5733 32.3946 14.2861 31.5037 14.2861Z" fill="#FBA937" />
            <path d="M13.6855 24.5316H7.53821C6.6473 24.5316 5.93457 23.8188 5.93457 22.9279C5.93457 22.037 6.6473 21.3243 7.53821 21.3243H13.5964C14.4873 21.3243 15.2 22.037 15.2 22.9279C15.2891 23.8188 14.5764 24.5316 13.6855 24.5316Z" fill="#FBA937" />
            <path d="M37.4726 40.9243C44.1151 40.9243 49.4999 35.5395 49.4999 28.897C49.4999 22.2545 44.1151 16.8697 37.4726 16.8697C30.8301 16.8697 25.4453 22.2545 25.4453 28.897C25.4453 35.5395 30.8301 40.9243 37.4726 40.9243Z" fill="#FBA937" />
            <path d="M31.3174 28.8262L35.4916 33.0004L43.7626 24.8187" stroke="white" stroke-width="2" stroke-miterlimit="10" />
        </svg>
    )
}

export default ListIcon;

